import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import i18n from 'i18next';
import { AppConfig } from 'shared/api';
import { commonApi } from 'shared/api/commonApi';
import { DEFAULT_LANGUAGE } from 'shared/consts';
import { ELanguages } from 'shared/typings';
import { WebApp } from 'shared/utils';

interface ICommonSlice {
	infinityScrollOffset: number;
	infinityScrollPage: number;
	language: ELanguages;
	isOpenFrozenPopup: boolean;
	isAllowWrite: boolean;
}

const initialState: ICommonSlice = {
	infinityScrollOffset: 0,
	infinityScrollPage: 1,
	language: ELanguages.RU,
	isOpenFrozenPopup: false,
	isAllowWrite: !!WebApp?.initDataUnsafe.user?.allows_write_to_pm,
};

export const commonSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		setInfinityScrollOffset: (state, action: PayloadAction<number>) => {
			state.infinityScrollOffset = action.payload;
		},
		setInfinityScrollPage: (state, action: PayloadAction<number>) => {
			state.infinityScrollPage = action.payload;
		},
		clearInfinityScroll: (state) => {
			state.infinityScrollOffset = 0;
			state.infinityScrollPage = 1;
		},
		setLanguage: (state, action: PayloadAction<ELanguages>) => {
			state.language = action.payload;
		},
		setIsOpenFrozenPopup: (state, action: PayloadAction<boolean>) => {
			state.isOpenFrozenPopup = action.payload;
		},
		setIsAllowWrite: (state, action: PayloadAction<boolean>) => {
			state.isAllowWrite = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			commonApi.endpoints?.appConfigRetrieve.matchFulfilled,
			(state, action: PayloadAction<AppConfig>) => {
				const lang = action.payload.user?.language
					? DEFAULT_LANGUAGE(action.payload.user.language as ELanguages)
					: DEFAULT_LANGUAGE(i18n.language as ELanguages);
				state.language = lang;
				localStorage.setItem('user_id', action.payload.user?.user_id || '');
			},
		);
	},
});

export default commonSlice.reducer;
export const {
	setInfinityScrollOffset,
	setInfinityScrollPage,
	clearInfinityScroll,
	setIsOpenFrozenPopup,
	setIsAllowWrite,
} = commonSlice.actions;
